import { VALID_CATEGORY_SLUGS } from "@/lib/analytics";
import { normalizeCategorySlug } from "@/lib/category-slug";

/** Shared palette for niche charts and UI (MrrDistributionChart, search dropdown, etc.) */
export const NICHE_PALETTE = [
  "#8b5cf6", "#06b6d4", "#f59e0b", "#22c55e", "#ef4444",
  "#ec4899", "#3b82f6", "#14b8a6", "#f97316", "#a855f7",
  "#64748b", "#84cc16"
];

/** Returns a stable color for a category slug, matching the chart bar colors. */
export function getNicheColor(categorySlug: string): string {
  const normalized = normalizeCategorySlug(categorySlug);
  const index = VALID_CATEGORY_SLUGS.indexOf(normalized);
  return NICHE_PALETTE[index >= 0 ? index % NICHE_PALETTE.length : 0];
}
